var forEach = require('./forEach');

module.exports = function map(arr, fn) {
  var newArr = [];

  forEach(arr, function(key, item) {
    newArr.push(fn(key, item));
  });

  return newArr;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/chickencurry/lib/map.js
// module id = ims4
// module chunks = 0